import React, { useEffect } from 'react'
import { AgreementEditPageProps } from './AgreementEditPage.types'
// import styles from './AgreementEditPage.module.scss'
// import cl from 'classnames'
import { inject } from 'mobx-react'
import { AGREEMENT_PAGE_STORE } from 'store'
import { AgreementPage } from '../AgreementPage'

const AgreementEditPageComponent = (props: AgreementEditPageProps) => {
  const {
    [AGREEMENT_PAGE_STORE]: {
      getAgreementById,
      updateAgreement
    },
    match: { params: { id } }
  } = props

  useEffect(() => getAgreementById(id), [getAgreementById, id])

  return (
    <AgreementPage
      onSubmit={updateAgreement}
    />
  )
}

const AgreementEditPage = inject(
  AGREEMENT_PAGE_STORE
)(AgreementEditPageComponent)
export { AgreementEditPage }
